// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__c0Q1z","links":"Footer_links__X9iFI","name":"Footer_name__R6iY7"};